export const getSnippetPreviewMessage = (text: string, fieldBindings: { key: string; value: string | null }[] = []) => {
    if (!fieldBindings || fieldBindings.length === 0) {
        return text;
    }

    for (const { key, value } of fieldBindings) {
        text = text.replaceAll(`{{field=>${key}}}`, value ?? '');
    }

    return text.trim();
};
